import type { Control, FieldValues } from 'react-hook-form';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';
import OdinController from '../../dynamic-form/odin-controller.component';
import Signature from './signature.component';

export interface HfSignatureProps<TFieldValues extends FieldValues = FieldValues>
  extends DynamicFieldComponentProps<string> {
  control: Control<TFieldValues>;
  name: string;
}

export default function HfSignature<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  labelStyles,
}: HfSignatureProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Signature
          name={name}
          label={label}
          value={value}
          error={error?.message}
          readOnly={readOnly}
          required={required}
          onChange={onChange}
          labelStyles={labelStyles}
        />
      )}
    />
  );
}
